import { getAdditionalTestTypeName } from "./helperfunc";

export const useSettingFieldType = (baseName) => {
  let testType = baseName.split('[')[baseName.split('[').length - 1].replaceAll(']', '')
  const isAdditional = baseName.includes('additional_tests[')
  let field = attributes.includes(testType) && testType
  if (field) {
    const eyeCode = field.match(/(OD|OS|OU)/i)?.[0]
    field = field.replace(/^(od_|os_|ou_)/, '');
    return `${field}_${eyeCode}`
  }
  else if (isAdditional === true) {
    return getAdditionalTestTypeName(baseName, true)
  }
  testType = dialationKeys.includes(testType) ? dialationFields[testType] : testType
  if (baseName.includes('preliminary_binocular_testing') && testType == 'notes') {
    if (baseName.includes('[binocular]')) {
      testType = "binocular_note"
    }
    else if (baseName.includes('[priliminaries]')) {
      testType = 'priliminaries_notes'
    }
  }
  return testType
};

const dialationKeys = ['reason', 'od', 'os']
const dialationFields = {
  reason: 'dialation_inactive_reason',
  od: 'dialation_od',
  os: 'dialation_os'
}

const attributes = ['od_tear_film', 'os_tear_film', 'ou_tear_film', 'od_cornea', 'os_cornea', 'ou_cornea', 'od_sclera', 'os_sclera', 'ou_sclera', 'od_angle', 'os_angle', 'ou_angle', 'od_iris', 'os_iris', 'ou_iris', 'od_bulbar_conj', 'os_bulbar_conj', 'ou_bulbar_conj', 'od_lens', 'os_lens', 'ou_lens', 'od_palpebral_conj', 'os_palpebral_conj', 'ou_palpebral_conj', 'od_ac', 'os_ac', 'ou_ac', 'od_lids_lashes', 'os_lids_lashes', 'ou_lids_lashes', 'od_macula', 'os_macula', 'ou_macula', 'od_vessels', 'os_vessels', 'ou_vessels', 'od_post_pole', 'os_post_pole', 'ou_post_pole', 'od_vitreous', 'os_vitreous', 'ou_vitreous', 'od_periphery', 'os_periphery', 'ou_periphery']